<template lang="pug">
  validation-observer(
    v-slot="{ invalid, validate }"
  )
    .question-attachments
      template(v-if="question.settings.is_text_required")
        template(v-if="!readonly")
          validation-provider(
            :rules="`required|max:${constants.INPUT_LENGTH.textArea}`"
            name="text"
            v-slot="{ errors }"
          )
            ev-tiptap-editor.mb-5(
              v-model="text"
              placeholder="Напишите необходимую информацию"
              :counter="constants.INPUT_LENGTH.textArea"
              :error-messages="errors"
            )
        template(v-else)
          .pre-wrap(
            v-if="!!text"
            v-html="text"
          )

          dv-alert(
            v-else
          ) Нет ответа

      template(v-if="question.settings.is_link_required")
        links-input(
          v-model="links"
          :readonly="readonly"
        )

      template(v-if="question.settings.is_document_required")
        v-card(flat).my-1.ev-card
          .pa-2.d-flex.align-center
            v-icon.mr-2 mdi-file-multiple-outline
            .d-flex.flex-column.mr-2
              span.text-subtitle-1 Документы
              span.text-caption {{ constants.EXTENSIONS.files.description }}
            template(v-if="!readonly")
              file-upload(
                accept="all"
                @upload="changeDocuments"
              )
                template(#activator)
                  v-btn(
                    color="accent"
                    fab small
                  )
                    v-icon mdi-plus

        template(v-if="!!documents.length")
          v-card-text.white
            v-simple-table
              tbody
                template(v-for="(document, index) in documents")
                  tr(:key="document.url")
                    td
                      a(
                        :title="document.original_name"
                        :href="document.url"
                        target="_blank"
                      ) {{ document.original_name }}
                    template(v-if="!readonly")
                      td.text-right
                        app-tooltip(
                          top
                        )
                          template(#reason)
                            span Удалить
                          app-button.mr-n3(
                            color="redesignError"
                            icon
                            @click="deleteDocument(document.id)"
                          )
                            v-icon $itrash

      template(v-if="question.settings.is_image_required")
        v-card(flat).my-1.ev-card
          .pa-2.d-flex
            v-icon.mr-2 mdi-image-multiple-outline
            .d-flex.flex-column.mr-2
              span.text-subtitle-1 Картинки
              span.text-caption {{ constants.EXTENSIONS.images.description }}
          template(v-if="!readonly")
            v-card-text
              images(
                :init-images="images"
                @addImg="addImg"
                @deleteImg="deleteImg"
              )
          template(v-else)
            template(v-if="!!images.length")
              v-card-text
                template(v-for="image in images")
                  ev-image-preview(
                    :key="image.url"
                    :src="image.url"
                    max-width="300"
                    max-height="300"
                  )

      slot(
        :invalid="invalid"
        :validate="validate"
      )
</template>

<script>
import DvAlert from '@/packages/ui/components/alerts/DvAlert.vue';
import FileUpload from '@/components/FileUpload.vue';
import LinksInput from '@/components/inputs/LinksInput.vue';
import Images from '../Images.vue';

import { INPUT_LENGTH } from '@/constants/inputLength';
import { EXTENSIONS } from '@/constants/filesExtensions';

// Смешанный ответ TYPE = 3
export default {
  name: 'QuestionAttachment',
  components: {
    FileUpload,
    Images,
    LinksInput,
    DvAlert,
  },
  props: {
    value: { type: Object, default: undefined },
    question: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      text: undefined,
      links: [],
      images: [],
      documents: [],

      deletedFiles: {
        images: [],
        documents: [],
      },
    };
  },
  computed: {
    constants() {
      return {
        INPUT_LENGTH,
        EXTENSIONS,
      };
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val?.images) {
          this.images = val.images;
        }

        if (val?.documents) {
          this.documents = val.documents;
        }

        if (val?.responseValue?.text) {
          this.text = val.responseValue.text;
        }

        if (val?.responseValue?.links) {
          this.links = val.responseValue.links;
        }
      },
      immediate: true,
    },
    images: {
      handler(val) {
        const { value } = this;

        this.$set(value, 'images', val);
        this.$emit('input', value);
      },
      deep: true,
    },
    documents: {
      handler(val) {
        const { value } = this;

        this.$set(value, 'documents', val);
        this.$emit('input', value);
      },
      deep: true,
    },
    text: {
      handler(val) {
        const { value } = this;

        this.$set(value, 'responseValue', {
          ...value?.responseValue || {},
          text: val,
        });
        this.$emit('input', value);
      },
      deep: true,
    },
    links: {
      handler(val) {
        const { value } = this;

        this.$set(value, 'responseValue', {
          ...value?.responseValue || {},
          links: val,
        });
        this.$emit('input', value);
      },
      deep: true,
    },
    'deletedFiles.images': {
      handler(val) {
        const { value } = this;

        this.$set(value, 'deletedFiles', {
          ...value?.deletedFiles,
          images: val,
        });
        this.$emit('value', value);
      },
      deep: true,
    },
    'deletedFiles.documents': {
      handler(val) {
        const { value } = this;

        this.$set(value, 'deletedFiles', {
          ...value?.deletedFiles,
          documents: val,
        });
        this.$emit('value', value);
      },
      deep: true,
    },
  },
  methods: {
    changeDocuments({ file_name, original_name, url }) {
      this.documents = [
        {
          file_name,
          original_name,
          description: 'description',
          url,
        },
        ...this.documents,
      ];
    },
    addImg(image) {
      this.images.push(image);
    },
    deleteImg(id) {
      if (id) this.deletedFiles.images.push(id);
    },
    deleteDocument(id) {
      if (id) this.deletedFiles.documents.push(id);
    },
  },
};
</script>
